module.exports = __webpack_public_path__ + "media/images/icon_schedule-occasional-12e1db676c1429cc614b5f7a455ac267.svg";